/** Canonical physical gift card receipt types from admin. */
export const PHYSICAL_RECEIPT_TYPES = [
  "physicalCashReceipt",
  "physicalCreditCardReceipt",
  "physicalDebitCardReceipt",
  "physicalActivationReceipt",
  "physicalNoReceipt",
] as const;

export type PhysicalReceiptType = (typeof PHYSICAL_RECEIPT_TYPES)[number];

const RECEIPT_LABEL_TO_TYPE: Record<string, PhysicalReceiptType> = {
  "Cash receipt": "physicalCashReceipt",
  "Credit card receipt": "physicalCreditCardReceipt",
  "Debit card receipt": "physicalDebitCardReceipt",
  "Activation receipt": "physicalActivationReceipt",
  "No receipt": "physicalNoReceipt",
};

/** Keys that may appear on grouped country rates from admin (legacy typo included). */
export const NO_RECEIPT_RATE_KEYS = ["physicalNoReceipt", "physicalNoreceipt"];

export function normalizeReceiptType(receiptName?: string): PhysicalReceiptType {
  if (!receiptName) return "physicalNoReceipt";

  if (receiptName === "physicalNoreceipt") {
    return "physicalNoReceipt";
  }

  if (RECEIPT_LABEL_TO_TYPE[receiptName]) {
    return RECEIPT_LABEL_TO_TYPE[receiptName];
  }

  if (
    PHYSICAL_RECEIPT_TYPES.includes(receiptName as PhysicalReceiptType)
  ) {
    return receiptName as PhysicalReceiptType;
  }

  return "physicalNoReceipt";
}

export function formatReceiptLabel(type?: string): string {
  if (!type) return "";
  switch (normalizeReceiptType(type)) {
    case "physicalCashReceipt":
      return "Cash receipt";
    case "physicalDebitCardReceipt":
      return "Debit card receipt";
    case "physicalCreditCardReceipt":
      return "Credit card receipt";
    case "physicalActivationReceipt":
      return "Activation receipt";
    case "physicalNoReceipt":
      return "No receipt";
    default:
      return type;
  }
}

export function getRatesForReceiptKey(
  rates: Record<string, unknown> | undefined,
  key: string
): any[] {
  if (!rates) return [];
  if (key === "physicalNoReceipt" || key === "physicalNoreceipt") {
    const bucket =
      rates.physicalNoReceipt ?? rates.physicalNoreceipt;
    return Array.isArray(bucket) ? bucket : [];
  }
  const bucket = rates[key];
  return Array.isArray(bucket) ? bucket : [];
}
